import React from 'react';
import {TableHead, TableRow, TableCell} from '@mui/material';

const TableHeader = ({headers}) => {
  return (
<TableHead>
  <TableRow
    sx={{
      backgroundColor: 'var(--primary-blue-color)',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    }}
  >
    {headers?.map((item, index) => (
      <TableCell
        key={index}
        sx={{
          border: '1px solid rgba(255,255,255,0.2)',
          color: 'white',
          fontWeight: '600',
          textAlign: 'center',
          padding: '16px 12px',
          fontSize: '14px',
          position: 'sticky', 
          top: 0, 
          backgroundColor: 'var(--primary-blue-color)', 
          zIndex: index === 0 ? 12 : 11, // First column has higher z-index
          minWidth: index === 0 ? '200px' : '150px',
          maxWidth: index === 0 ? '250px' : '200px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          // First column sticky logic
          ...(index === 0 && {
            position: 'sticky',
            left: 0,
            zIndex: 12,
            backgroundColor: 'var(--primary-blue-color)',
            borderRight: '2px solid rgba(255,255,255,0.3)',
            boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
          }),
        }}
      >
        {item?.label}
      </TableCell>
    ))}
  </TableRow>
</TableHead>
  );
};

export default TableHeader;
